import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {SocialSharing} from "@ionic-native/social-sharing";


@Component({
    selector: 'page-default-progress',
    templateUrl: 'default-progress.html',
})
export class DefaultProgressPage {

    hide: any = false;

    AllDefaultData: any;
    ApointBookData: any;
    EnquiryData: any;
    FeedData: any;

    date: any;

    Date:any;
    DisplayDate = "";
    monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    ShareDatawhatsapp: any;


    School = 'All';
    SchoolData = {};

    constructor(public navCtrl: NavController,
                public service: ServiceProvider,
                public viewCtrl: ViewController,
                public socialSharing: SocialSharing,
                public loadingCtrl: LoadingController,
                public platform: Platform,
                public navParams: NavParams) {

        this.platform.ready().then(() => {

            this.Date = new Date();
            this.DisplayDate = this.Date.getDate() + "-" + this.monthNames[this.Date.getMonth()] + "-" + this.Date.getFullYear();
            this.Date = this.Date.toISOString();

            this.SchoolData = {
                "All": 0,
                "GWW": 2,
                "GWE": 3,
                "GEIS": 1
            };

            this.loadDataCount(this.SchoolData[this.School]);

        });
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad DefaultProgressPage');
    }


    active_tab(tab) {
        console.log(tab);
        this.School = tab;
        this.loadDataCount(this.SchoolData[this.School]);

    }


    loadDataCount(FSchoolId) {

        if(FSchoolId == 0){
            this.All_loadvalues();
        }
        else {
            this.SchoolReport(FSchoolId);
        }

    }

    All_loadvalues()  {

        let loading = this.loadingCtrl.create({
            content: 'Please wait...'
        });

        loading.present();

        this.AllDefaultData = [];
        this.ApointBookData = [];
        this.EnquiryData = [];
        this.FeedData = [];

        console.log("Date", this.date);

        this.service.httpcall('app_web_service/get_Default_progress_Data?').subscribe(data => {

            if (data) {

                this.AllDefaultData = data['Data'];
                this.ApointBookData = data['Apoint'];
                this.EnquiryData = data['EnQ'];
                this.FeedData = data['FeedBack'];
                console.log('AllSorceData', this.AllDefaultData);
                loading.dismiss();

                var Data = "*"+this.DisplayDate+" Default & Progress Report*\n";
                var ApointBook = '';
                var EnQ = '';
                var FeedBack = '';


                Data += "\n *Data* \n_______________________\n\n" +
                    "*Today* \n " +
                    "Default \t : " + this.AllDefaultData['TodaysDefaultStatus'] + "/" + this.AllDefaultData['TodaysData'] + "\n " +
                    "Not Default : " + this.AllDefaultData['TodaysRemaining'] + "/" + this.AllDefaultData['TodaysData'] + "\n " +
                    "Progress \t : " + this.AllDefaultData['TodaysPosted'] + "/" + this.AllDefaultData['TodaysData'] + "\n\n" +

                    "*Yesterday* \n " +
                    "Default \t : " + this.AllDefaultData['YestDefaultStatus'] + "/" + this.AllDefaultData['YesterDays'] + "\n " +
                    "Not Default : " + this.AllDefaultData['YesterDaysRemaining'] + "/" + this.AllDefaultData['YesterDays'] + "\n " +
                    "Progress \t : " + this.AllDefaultData['YesterdayPosted'] + "/" + this.AllDefaultData['YesterDays'] + "\n\n" +

                    "*Last 5 Days* \n " +
                    "Default \t : " + this.AllDefaultData['LastFiveDaystDefaultStatus'] + "/" + this.AllDefaultData['LastFiveDays'] + "\n " +
                    "Not Default : " + this.AllDefaultData['LastFiveDaysRemaining'] + "/" + this.AllDefaultData['LastFiveDays'] + "\n " +
                    "Progress \t : " + this.AllDefaultData['LastFiveDaysPosted'] + "/" + this.AllDefaultData['LastFiveDays'] + "\n\n" +

                    "*Last 30 Days* \n " +
                    "Default \t : " + this.AllDefaultData['LastThirtyDaystDefaultStatus'] + "/" + this.AllDefaultData['LastThirtyDaysData'] + "\n " +
                    "Not Default : " + this.AllDefaultData['LastThirtyDaysDaysRemaining'] + "/" + this.AllDefaultData['LastThirtyDaysData'] + "\n " +
                    "Progress \t : " + this.AllDefaultData['LastThirtyDaysPosted'] + "/" + this.AllDefaultData['LastThirtyDaysData'] + "\n\n" +

                    "*Past Days* \n " +
                    "Default \t : " + this.AllDefaultData['PastDaysDefaultStatus'] + "/" + this.AllDefaultData['PastDaysData'] + "\n " +
                    "Not Default : " + this.AllDefaultData['PostDayRemaining'] + "/" + this.AllDefaultData['PastDaysData'] + "\n " +
                    "Progress \t : " + this.AllDefaultData['PastPosted'] + "/" + this.AllDefaultData['PastDaysData'] + "\n\n";


                ApointBook += "\n *Appointment Book* \n_______________________\n\n" +
                    "*Today* \n " +
                    "Default \t : " + this.ApointBookData['TodaysDefaultStatus'] + "/" + this.ApointBookData['TodaysData'] + "\n " +
                    "Not Default : " + this.ApointBookData['TodaysDataRem'] + "/" + this.ApointBookData['TodaysData'] + "\n " +
                    "Progress \t : " + this.ApointBookData['TodaysPosted'] + "/" + this.ApointBookData['TodaysData'] + "\n\n" +

                    "*Yesterday* \n " +
                    "Default \t : " + this.ApointBookData['YestDefaultStatus'] + "/" + this.ApointBookData['YesterDays'] + "\n " +
                    "Not Default : " + this.ApointBookData['YestDayRem'] + "/" + this.ApointBookData['YesterDays'] + "\n " +
                    "Progress \t : " + this.ApointBookData['YesterdayPosted'] + "/" + this.ApointBookData['YesterDays'] + "\n\n" +

                    "*Last 5 Days* \n " +
                    "Default \t : " + this.ApointBookData['LastFiveDaystDefaultStatus'] + "/" + this.ApointBookData['LastFiveDays'] + "\n " +
                    "Not Default : " + this.ApointBookData['LastFiveDaysRem'] + "/" + this.ApointBookData['LastFiveDays'] + "\n " +
                    "Progress \t : " + this.ApointBookData['LastFiveDaysPosted'] + "/" + this.ApointBookData['LastFiveDays'] + "\n\n" +

                    "*Last 30 Days* \n " +
                    "Default \t : " + this.ApointBookData['LastThirtyDaystDefaultStatus'] + "/" + this.ApointBookData['LastThirtyDaysData'] + "\n " +
                    "Not Default : " + this.ApointBookData['LastThirtyDaysRem'] + "/" + this.ApointBookData['LastThirtyDaysData'] + "\n " +
                    "Progress \t : " + this.ApointBookData['LastThirtyDaysPosted'] + "/" + this.ApointBookData['LastThirtyDaysData'] + "\n\n" +

                    "*Past Days* \n " +
                    "Default \t :  " + this.ApointBookData['PastDaysDefaultStatus'] + "/" + this.ApointBookData['PastDaysData'] + "\n " +
                    "Not Default : " + this.ApointBookData['PastDaysDataRem'] + "/" + this.ApointBookData['PastDaysData'] + "\n " +
                    "Progress \t : " + this.ApointBookData['PastPosted'] + "/" + this.ApointBookData['PastDaysData'] + "\n\n";


                EnQ += "\n *Enquiry* \n_______________________\n\n" +
                    "*Today* \n " +
                    "Default \t : " + this.EnquiryData['TodaysDefaultStatus'] + "/" + this.EnquiryData['TodaysData'] + "\n " +
                    "Not Default : " + this.EnquiryData['TodaysDataRem'] + "/" + this.EnquiryData['TodaysData'] + "\n " +
                    "Progress \t : " + this.EnquiryData['TodaysPosted'] + "/" + this.EnquiryData['TodaysData'] + "\n\n" +

                    "*Yesterday* \n " +
                    "Default \t : " + this.EnquiryData['YestDefaultStatus'] + "/" + this.EnquiryData['YesterDays'] + "\n " +
                    "Not Default : " + this.EnquiryData['YesterDaysRem'] + "/" + this.EnquiryData['YesterDays'] + "\n " +
                    "Progress \t : " + this.EnquiryData['YesterdayPosted'] + "/" + this.EnquiryData['YesterDays'] + "\n\n" +

                    "*Last 5 Days* \n " +
                    "Default \t : " + this.EnquiryData['LastFiveDaystDefaultStatus'] + "/" + this.EnquiryData['LastFiveDays'] + "\n " +
                    "Not Default : " + this.EnquiryData['LastFiveDaysRem'] + "/" + this.EnquiryData['LastFiveDays'] + "\n " +
                    "Progress \t : " + this.EnquiryData['LastFiveDaysPosted'] + "/" + this.EnquiryData['LastFiveDays'] + "\n\n" +

                    "*Last 30 Days* \n " +
                    "Default \t : " + this.EnquiryData['LastThirtyDaystDefaultStatus'] + "/" + this.EnquiryData['LastThirtyDaysData'] + "\n " +
                    "Not Default : " + this.EnquiryData['LastThirtyDaysRem'] + "/" + this.EnquiryData['LastThirtyDaysData'] + "\n " +
                    "Progress \t : " + this.EnquiryData['LastThirtyDaysPosted'] + "/" + this.EnquiryData['LastThirtyDaysData'] + "\n\n" +

                    "*Past Days* \n " +
                    "Default \t : " + this.EnquiryData['PastDaysDefaultStatus'] + "/" + this.EnquiryData['PastDaysData'] + "\n " +
                    "Not Default : " + this.EnquiryData['PastDaysDataRem'] + "/" + this.EnquiryData['PastDaysData'] + "\n " +
                    "Progress \t : " + this.EnquiryData['PastPosted'] + "/" + this.EnquiryData['PastDaysData'] + "\n\n";

                FeedBack += "\n *Feedback* \n_______________________\n\n" +
                    "*Today* \n " +
                    "Default \t : " + this.FeedData['TodaysDefaultStatus'] + "/" + this.FeedData['TodaysData'] + "\n " +
                    "Not Default : " + this.FeedData['TodaysDataRem'] + "/" + this.FeedData['TodaysData'] + "\n " +
                    "Progress \t : " + this.FeedData['TodaysPosted'] + "/" + this.FeedData['TodaysData'] + "\n\n" +

                    "*Yesterday* \n " +
                    "Default \t : " + this.FeedData['YestDefaultStatus'] + "/" + this.FeedData['YesterDays'] + "\n " +
                    "Not Default : " + this.FeedData['YesterDaysRem'] + "/" + this.FeedData['YesterDays'] + "\n " +
                    "Progress \t : " + this.FeedData['YesterdayPosted'] + "/" + this.FeedData['YesterDays'] + "\n\n" +

                    "*Last 5 Days* \n " +
                    "Default \t : " + this.FeedData['LastFiveDaystDefaultStatus'] + "/" + this.FeedData['LastFiveDays'] + "\n " +
                    "Not Default : " + this.FeedData['LastFiveDaysRem'] + "/" + this.FeedData['LastFiveDays'] + "\n " +
                    "Progress \t : " + this.FeedData['LastFiveDaysPosted'] + "/" + this.FeedData['LastFiveDays'] + "\n\n" +

                    "*Last 30 Days* \n " +
                    "Default \t : " + this.FeedData['LastThirtyDaystDefaultStatus'] + "/" + this.FeedData['LastThirtyDaysData'] + "\n " +
                    "Not Default : " + this.FeedData['LastThirtyDaysRem'] + "/" + this.FeedData['LastThirtyDaysData'] + "\n " +
                    "Progress \t : " + this.FeedData['LastThirtyDaysPosted'] + "/" + this.FeedData['LastThirtyDaysData'] + "\n\n" +

                    "*Past Days* \n " +
                    "Default \t : " + this.FeedData['PastDaysDefaultStatus'] + "/" + this.FeedData['PastDaysData'] + "\n " +
                    "Not Default : " + this.FeedData['PastDaysDataRem'] + "/" + this.FeedData['PastDaysData'] + "\n " +
                    "Progress \t : " + this.FeedData['PastPosted'] + "/" + this.FeedData['PastDaysData'] + "\n\n";

                this.ShareDatawhatsapp = Data + ApointBook + EnQ + FeedBack;

                console.log("test21", this.ShareDatawhatsapp);


            } else {
                loading.dismiss();
            }

        })
    }

    SchoolReport(FSchoolId) {

        let loading = this.loadingCtrl.create({
            content: 'Please wait...'
        });

        loading.present();

        this.AllDefaultData = [];
        this.ApointBookData = [];
        this.EnquiryData = [];
        this.FeedData = [];

        console.log("Date", this.date);

        this.service.httpcall('app_web_service/get_all_SchoDefault_progress_Data?FSchoolId='+FSchoolId).subscribe(data => {

            if (data) {

                this.AllDefaultData = data['Data'];
                this.ApointBookData = data['Apoint'];
                this.EnquiryData = data['EnQ'];
                this.FeedData = data['FeedBack'];
                console.log('AllSorceData', this.AllDefaultData);
                loading.dismiss();

                var Data = "*"+this.DisplayDate+" Default & Progress Report*\n";
                var ApointBook = '';
                var EnQ = '';
                var FeedBack = '';


                Data += "\n *Data* \n_______________________\n\n" +
                    "*Today* \n " +
                    "Default \t : " + this.AllDefaultData['TodaysDefaultStatus'] + "/" + this.AllDefaultData['TodaysData'] + "\n " +
                    "Not Default : " + this.AllDefaultData['TodaysRemaining'] + "/" + this.AllDefaultData['TodaysData'] + "\n " +
                    "Progress \t : " + this.AllDefaultData['TodaysPosted'] + "/" + this.AllDefaultData['TodaysData'] + "\n\n" +

                    "*Yesterday* \n " +
                    "Default \t : " + this.AllDefaultData['YestDefaultStatus'] + "/" + this.AllDefaultData['YesterDays'] + "\n " +
                    "Not Default : " + this.AllDefaultData['YesterDaysRemaining'] + "/" + this.AllDefaultData['YesterDays'] + "\n " +
                    "Progress \t : " + this.AllDefaultData['YesterdayPosted'] + "/" + this.AllDefaultData['YesterDays'] + "\n\n" +

                    "*Last 5 Days* \n " +
                    "Default \t : " + this.AllDefaultData['LastFiveDaystDefaultStatus'] + "/" + this.AllDefaultData['LastFiveDays'] + "\n " +
                    "Not Default : " + this.AllDefaultData['LastFiveDaysRemaining'] + "/" + this.AllDefaultData['LastFiveDays'] + "\n " +
                    "Progress \t : " + this.AllDefaultData['LastFiveDaysPosted'] + "/" + this.AllDefaultData['LastFiveDays'] + "\n\n" +

                    "*Last 30 Days* \n " +
                    "Default \t : " + this.AllDefaultData['LastThirtyDaystDefaultStatus'] + "/" + this.AllDefaultData['LastThirtyDaysData'] + "\n " +
                    "Not Default : " + this.AllDefaultData['LastThirtyDaysDaysRemaining'] + "/" + this.AllDefaultData['LastThirtyDaysData'] + "\n " +
                    "Progress \t : " + this.AllDefaultData['LastThirtyDaysPosted'] + "/" + this.AllDefaultData['LastThirtyDaysData'] + "\n\n" +

                    "*Past Days* \n " +
                    "Default \t : " + this.AllDefaultData['PastDaysDefaultStatus'] + "/" + this.AllDefaultData['PastDaysData'] + "\n " +
                    "Not Default : " + this.AllDefaultData['PostDayRemaining'] + "/" + this.AllDefaultData['PastDaysData'] + "\n " +
                    "Progress \t : " + this.AllDefaultData['PastPosted'] + "/" + this.AllDefaultData['PastDaysData'] + "\n\n";


                ApointBook += "\n *Appointment Book* \n_______________________\n\n" +
                    "*Today* \n " +
                    "Default \t : " + this.ApointBookData['TodaysDefaultStatus'] + "/" + this.ApointBookData['TodaysData'] + "\n " +
                    "Not Default : " + this.ApointBookData['TodaysDataRem'] + "/" + this.ApointBookData['TodaysData'] + "\n " +
                    "Progress \t : " + this.ApointBookData['TodaysPosted'] + "/" + this.ApointBookData['TodaysData'] + "\n\n" +

                    "*Yesterday* \n " +
                    "Default \t : " + this.ApointBookData['YestDefaultStatus'] + "/" + this.ApointBookData['YesterDays'] + "\n " +
                    "Not Default : " + this.ApointBookData['YestDayRem'] + "/" + this.ApointBookData['YesterDays'] + "\n " +
                    "Progress \t : " + this.ApointBookData['YesterdayPosted'] + "/" + this.ApointBookData['YesterDays'] + "\n\n" +

                    "*Last 5 Days* \n " +
                    "Default \t : " + this.ApointBookData['LastFiveDaystDefaultStatus'] + "/" + this.ApointBookData['LastFiveDays'] + "\n " +
                    "Not Default : " + this.ApointBookData['LastFiveDaysRem'] + "/" + this.ApointBookData['LastFiveDays'] + "\n " +
                    "Progress \t : " + this.ApointBookData['LastFiveDaysPosted'] + "/" + this.ApointBookData['LastFiveDays'] + "\n\n" +

                    "*Last 30 Days* \n " +
                    "Default \t : " + this.ApointBookData['LastThirtyDaystDefaultStatus'] + "/" + this.ApointBookData['LastThirtyDaysData'] + "\n " +
                    "Not Default : " + this.ApointBookData['LastThirtyDaysRem'] + "/" + this.ApointBookData['LastThirtyDaysData'] + "\n " +
                    "Progress \t : " + this.ApointBookData['LastThirtyDaysPosted'] + "/" + this.ApointBookData['LastThirtyDaysData'] + "\n\n" +

                    "*Past Days* \n " +
                    "Default \t :  " + this.ApointBookData['PastDaysDefaultStatus'] + "/" + this.ApointBookData['PastDaysData'] + "\n " +
                    "Not Default : " + this.ApointBookData['PastDaysDataRem'] + "/" + this.ApointBookData['PastDaysData'] + "\n " +
                    "Progress \t : " + this.ApointBookData['PastPosted'] + "/" + this.ApointBookData['PastDaysData'] + "\n\n";


                EnQ += "\n *Enquiry* \n_______________________\n\n" +
                    "*Today* \n " +
                    "Default \t : " + this.EnquiryData['TodaysDefaultStatus'] + "/" + this.EnquiryData['TodaysData'] + "\n " +
                    "Not Default : " + this.EnquiryData['TodaysDataRem'] + "/" + this.EnquiryData['TodaysData'] + "\n " +
                    "Progress \t : " + this.EnquiryData['TodaysPosted'] + "/" + this.EnquiryData['TodaysData'] + "\n\n" +

                    "*Yesterday* \n " +
                    "Default \t : " + this.EnquiryData['YestDefaultStatus'] + "/" + this.EnquiryData['YesterDays'] + "\n " +
                    "Not Default : " + this.EnquiryData['YesterDaysRem'] + "/" + this.EnquiryData['YesterDays'] + "\n " +
                    "Progress \t : " + this.EnquiryData['YesterdayPosted'] + "/" + this.EnquiryData['YesterDays'] + "\n\n" +

                    "*Last 5 Days* \n " +
                    "Default \t : " + this.EnquiryData['LastFiveDaystDefaultStatus'] + "/" + this.EnquiryData['LastFiveDays'] + "\n " +
                    "Not Default : " + this.EnquiryData['LastFiveDaysRem'] + "/" + this.EnquiryData['LastFiveDays'] + "\n " +
                    "Progress \t : " + this.EnquiryData['LastFiveDaysPosted'] + "/" + this.EnquiryData['LastFiveDays'] + "\n\n" +

                    "*Last 30 Days* \n " +
                    "Default \t : " + this.EnquiryData['LastThirtyDaystDefaultStatus'] + "/" + this.EnquiryData['LastThirtyDaysData'] + "\n " +
                    "Not Default : " + this.EnquiryData['LastThirtyDaysRem'] + "/" + this.EnquiryData['LastThirtyDaysData'] + "\n " +
                    "Progress \t : " + this.EnquiryData['LastThirtyDaysPosted'] + "/" + this.EnquiryData['LastThirtyDaysData'] + "\n\n" +

                    "*Past Days* \n " +
                    "Default \t : " + this.EnquiryData['PastDaysDefaultStatus'] + "/" + this.EnquiryData['PastDaysData'] + "\n " +
                    "Not Default : " + this.EnquiryData['PastDaysDataRem'] + "/" + this.EnquiryData['PastDaysData'] + "\n " +
                    "Progress \t : " + this.EnquiryData['PastPosted'] + "/" + this.EnquiryData['PastDaysData'] + "\n\n";

                FeedBack += "\n *Feedback* \n_______________________\n\n" +
                    "*Today* \n " +
                    "Default \t : " + this.FeedData['TodaysDefaultStatus'] + "/" + this.FeedData['TodaysData'] + "\n " +
                    "Not Default : " + this.FeedData['TodaysDataRem'] + "/" + this.FeedData['TodaysData'] + "\n " +
                    "Progress \t : " + this.FeedData['TodaysPosted'] + "/" + this.FeedData['TodaysData'] + "\n\n" +

                    "*Yesterday* \n " +
                    "Default \t : " + this.FeedData['YestDefaultStatus'] + "/" + this.FeedData['YesterDays'] + "\n " +
                    "Not Default : " + this.FeedData['YesterDaysRem'] + "/" + this.FeedData['YesterDays'] + "\n " +
                    "Progress \t : " + this.FeedData['YesterdayPosted'] + "/" + this.FeedData['YesterDays'] + "\n\n" +

                    "*Last 5 Days* \n " +
                    "Default \t : " + this.FeedData['LastFiveDaystDefaultStatus'] + "/" + this.FeedData['LastFiveDays'] + "\n " +
                    "Not Default : " + this.FeedData['LastFiveDaysRem'] + "/" + this.FeedData['LastFiveDays'] + "\n " +
                    "Progress \t : " + this.FeedData['LastFiveDaysPosted'] + "/" + this.FeedData['LastFiveDays'] + "\n\n" +

                    "*Last 30 Days* \n " +
                    "Default \t : " + this.FeedData['LastThirtyDaystDefaultStatus'] + "/" + this.FeedData['LastThirtyDaysData'] + "\n " +
                    "Not Default : " + this.FeedData['LastThirtyDaysRem'] + "/" + this.FeedData['LastThirtyDaysData'] + "\n " +
                    "Progress \t : " + this.FeedData['LastThirtyDaysPosted'] + "/" + this.FeedData['LastThirtyDaysData'] + "\n\n" +

                    "*Past Days* \n " +
                    "Default \t : " + this.FeedData['PastDaysDefaultStatus'] + "/" + this.FeedData['PastDaysData'] + "\n " +
                    "Not Default : " + this.FeedData['PastDaysDataRem'] + "/" + this.FeedData['PastDaysData'] + "\n " +
                    "Progress \t : " + this.FeedData['PastPosted'] + "/" + this.FeedData['PastDaysData'] + "\n\n";

                this.ShareDatawhatsapp = Data + ApointBook + EnQ + FeedBack;

                console.log("test21", this.ShareDatawhatsapp);


            } else {
                loading.dismiss();
            }

        })
    }

    whatsAppShareBTN(){

      console.log("shareBTN data",this.ShareDatawhatsapp);

      this.socialSharing.shareViaWhatsApp(this.ShareDatawhatsapp,"","").then(() => {
        // Success!
        console.log("success");
      }).catch(() => {
        // Error!
        console.log("Error");
      });

    }

    doRefresh(refresher) {
        console.log('Begin async operation', refresher);

        this.loadDataCount(this.SchoolData[this.School]);

        setTimeout(() => {
            console.log('Async operation has ended');

            refresher.complete();
        }, 2000);
    }

    backBTN() {
        this.viewCtrl.dismiss();
    }


}



// WEBPACK FOOTER //
// ./src/pages/default-progress/default-progress.ts